import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=1998aac0"
import script from "./MenuIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=1998aac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports